<template>
  <div>
    <!-- begin #header -->
    <div id="header" class="header navbar-default">
      <!-- begin navbar-header -->
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle pull-right"
          v-on:click="toggleMobileRightSidebar"
          v-if="pageOptions.pageWithTwoSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <button
          type="button"
          class="navbar-toggle pull-left"
          v-on:click="toggleMobileSidebar"
          v-if="pageOptions.pageWithTwoSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <router-link to="/admin/dashboard" class="navbar-brand">
          <a-icon type="home" :style="{ display: 'inline-flex' }" />
          {{ $root.appName }}
        </router-link>
        <button
          type="button"
          class="navbar-toggle"
          v-on:click="toggleMobileSidebar"
          v-if="
            !pageOptions.pageWithTwoSidebar &&
              !pageOptions.pageWithTopMenu &&
              !pageOptions.pageWithoutSidebar
          "
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <button
          type="button"
          class="navbar-toggle"
          v-on:click="toggleMobileTopMenu"
          v-if="pageOptions.pageWithTopMenu && pageOptions.pageWithoutSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <button
          type="button"
          class="navbar-toggle p-0 m-r-0"
          v-on:click="toggleMobileMegaMenu"
          v-if="pageOptions.pageWithMegaMenu"
        >
          <span class="fa-stack fa-lg text-inverse m-t-2">
            <i class="far fa-square fa-stack-2x"></i>
            <i class="fa fa-cog fa-stack-1x"></i>
          </span>
        </button>
      </div>
      <!-- end navbar-header -->

      <header-mega-menu v-if="pageOptions.pageWithMegaMenu"></header-mega-menu>

      <!-- begin header-nav -->
      <ul class="navbar-nav navbar-right">
        <li
          v-if="!pageOptions.pageWithLanguageBar"
          v-bind:class="{ 'hidden-sm': pageOptions.pageWithMegaMenu }"
        >
          <form class="navbar-form" v-on:submit="checkForm">
            <div class="form-group">
              <input type="text" class="form-control" placeholder="Enter keyword" />
              <button type="submit" class="btn btn-search">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </form>
        </li>
        <!-- <li class="dropdown">
          <b-dropdown
            variant="link"
            menu-class="media-list dropdown-menu-right"
            toggle-class="f-s-14"
          >
            <template slot="button-content">
              <i class="fa fa-bell"></i>
              <span class="label">0</span>
            </template>
            <b-dropdown-header>NOTIFICATIONS (0)</b-dropdown-header>
            <li class="text-center width-300 p-b-10">No notification found</li>
          </b-dropdown>
        </li> -->
        <li class="dropdown navbar-language" v-if="pageOptions.pageWithLanguageBar">
          <b-dropdown variant="link" menu-class="p-b-0">
            <template slot="button-content">
              <span :class="`flag-icon flag-icon-${flag}`" :title="flag"></span>
            </template>
            <b-dropdown-item
              href="#"
              v-for="language in languages"
              :key="language.code"
              @click="changeLanguage(language)"
            >
              <span :class="`flag-icon flag-icon-${language.icon}`" :title="language.icon"></span>
              {{ language.caption }}
            </b-dropdown-item>
          </b-dropdown>
        </li>
        <li class="dropdown navbar-user">
          <b-dropdown variant="link" menu-class="dropdown-menu-right" class="user-dropdown-header">
            <template slot="button-content">
              <span class="d-none d-md-inline">{{ userName }}</span>
              <div class="image image-icon bg-black text-grey-darker">
                <img :src="userProfile" alt />
              </div>
              <b class="caret"></b>
            </template>
            <!-- <b-dropdown-item href="javascript:;">Edit Profile</b-dropdown-item> -->
            <!-- <b-dropdown-item href="javascript:;">
              <span class="badge badge-danger pull-right">2</span>
              Inbox
            </b-dropdown-item> -->
            <!-- <b-dropdown-item href="javascript:;">Calendar</b-dropdown-item>
            <b-dropdown-item href="javascript:;">Setting</b-dropdown-item> -->
            <b-dropdown-item @click.prevent="changePassword">{{ $t('changePassword') }}</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item href="#" @click="logout">Log Out</b-dropdown-item>
          </b-dropdown>
        </li>
        <li class="divider d-none d-md-block" v-if="pageOptions.pageWithTwoSidebar"></li>
        <li class="d-none d-md-block" v-if="pageOptions.pageWithTwoSidebar">
          <a
            href="javascript:;"
            v-on:click="toggleRightSidebar"
            data-click="right-sidebar-toggled"
            class="f-s-14"
          >
            <i class="fa fa-th"></i>
          </a>
        </li>
      </ul>
      <!-- end header navigation right -->
    </div>
    <!-- end #header -->
    <a-modal
      v-if="show_modal_change_pwd"
      v-model="show_modal_change_pwd"
      :title="$t('changePassword')"
      :centered="true"
      :maskClosable="false"
      :okText="$t('save')"
      :zIndex="1020"
      :confirmLoading="waiting"
      width="400px"
      @ok="onSave"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="required">{{ $t('user.oldPassword') }}</label>
            <input
              v-model="model.old_password"
              type="password"
              class="form-control"
              :class="{ 'is-invalid': errors.has('old_password') }"
            />
            <div
              class="invalid-feedback"
              v-if="errors.has('old_password')"
            >{{ errors.first('old_password') }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="required">{{ $t('user.newPassword') }}</label>
            <input
              v-model="model.new_password"
              type="password"
              class="form-control"
              :class="{ 'is-invalid': errors.has('new_password') }"
            />
            <div
              class="invalid-feedback"
              v-if="errors.has('new_password')"
            >{{ errors.first('new_password') }}</div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import PageOptions from '../../config/PageOptions.vue'
import HeaderMegaMenu from './HeaderMegaMenu.vue'
import { Errors } from 'form-backend-validation'

export default {
  name: 'Header',
  components: {
    HeaderMegaMenu
  },
  data() {
    return {
      errors: new Errors(),
      pageOptions: PageOptions,
      show_modal_change_pwd: false,
      waiting: false,
      model: {
        old_password: null,
        new_password: null
      },
      languages: [
        { code: 'kh', icon: 'kh', caption: 'ខ្មែរ' },
        { code: 'en', icon: 'us', caption: 'English' }
      ]
    }
  },
  computed: {
    userProfile() {
      return this.$store.state.authUser.user.user_profile
    },
    userName() {
      return this.$store.state.authUser.user.user_name
    },
    flag() {
      if (this.$root.$i18n.locale === 'kh') return 'kh'
      else if (this.$root.$i18n.locale === 'en') return 'us'
    }
  },
  methods: {
    toggleMobileSidebar() {
      this.pageOptions.pageMobileSidebarToggled = !this.pageOptions
        .pageMobileSidebarToggled
    },
    toggleMobileRightSidebar() {
      this.pageOptions.pageMobileRightSidebarToggled = !this.pageOptions
        .pageMobileRightSidebarToggled
    },
    toggleMobileTopMenu() {
      this.pageOptions.pageMobileTopMenu = !this.pageOptions.pageMobileTopMenu
    },
    toggleMobileMegaMenu() {
      this.pageOptions.pageMobileMegaMenu = !this.pageOptions.pageMobileMegaMenu
    },
    toggleRightSidebar() {
      this.pageOptions.pageRightSidebarToggled = !this.pageOptions
        .pageRightSidebarToggled
    },
    checkForm: function(e) {
      e.preventDefault()
      this.$router.push({ path: '/extra/search' })
    },
    async logout() {
      await this.$store.dispatch('logout')
      this.$router.push({ name: 'login' })
    },
    changeLanguage(language) {
      this.$root.$i18n.locale = language.code
    },
    pickChild(child) {
      this.$store.commit('SET_SELECTED_STUDENT', child)
    },
    changePassword() {
      this.show_modal_change_pwd = true
    },
    onSave(){
      this.waiting = true
      this.$store
        .dispatch('security/user/changePassword', this.model)
        .then(response => {
          this.show_modal_change_pwd = false
          this.$toasted.success(response.message)
          this.model.old_password = null
          this.model.new_password = null
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>

<style scoped>
img {
  object-fit: cover;
  object-position: top;
  height: auto !important;
}
</style>

<style lang="sass">
@media (min-width: 768px)
  .header
    display: flex !important
    flex-direction: row !important
    align-items: center !important

    .navbar-header
      flex-grow: 1 !important

  .header .navbar-right
    display: flex !important
    flex-direction: row !important
    align-items: center !important

  .user-dropdown-header button
    display: flex !important
    justify-content: center !important
    align-items: center !important

    .image.image-icon
      margin: 0 3px !important
</style>
